import { HIDDEN_INPUT_FIELDS } from "@/lib/attribution-fields";

/**
 * Renders the hidden attribution inputs that the pre-consent bootstrap
 * (see src/lib/attribution-bootstrap.ts) populates. They are real
 * `<input type="hidden">` elements, so no form library can exclude them.
 *
 * The values are ALSO read directly from `window.gjAttribution` when the
 * submission payload is built (see src/lib/submit-lead.ts) — delivery never
 * depends on DOM mutation alone.
 */
export function AttributionFields() {
  return (
    <>
      {HIDDEN_INPUT_FIELDS.map((name) => (
        <input key={name} type="hidden" data-gj-attr="1" name={name} defaultValue="" />
      ))}
    </>
  );
}
